/* Format integration name for UI */
const getPrettyIntegrationName = (integrationName) => {
	switch (integrationName) {
		case "ukg-pro":
			return "UKGPro";
		case "bamboohr":
			return "BambooHR";
		case "adp-wfn":
			return "ADP";
		case "adp-vantage":
			return "ADP";
		default:
			//Capitalize the first letter
			if (integrationName.length > 0) {
				return (integrationName = integrationName[0].toUpperCase() + integrationName.slice(1));
			}
			return "";
	}
};

export default getPrettyIntegrationName;
